import React, { useContext } from 'react'
import { store } from '../../stores/pages'
import classNames from 'classnames'

export default function Sidebar({children}) {
  const { mobileSidebar, viewingPreview, showPublish } = useContext(store)

  const sidebarClasses = classNames({
    "producer-form": true,
    "mobile-previewing": !mobileSidebar,
    "d-none": viewingPreview && !showPublish,
  })

  return (
    <div className={sidebarClasses}>
      {children}
    </div>
  )
}
